module.exports = __webpack_public_path__ + "img/deployment-icon.ea424841.png";